"use client"

import { useState } from "react"

// Custom-query instructions can run several hundred lines; clamp the preview
// and let the user expand it into a scrollable block.
const QUESTION_PREVIEW_LEN = 180

// The campaign instruction shown inside an enrichment popover: truncated by
// default, expandable into a bounded scrollable block that keeps line breaks.
export function ExpandableQuestion({
  question,
  showFullLabel,
  showLessLabel,
}: {
  question: string
  showFullLabel: string
  showLessLabel: string
}) {
  const [expanded, setExpanded] = useState(false)
  const isLong = question.length > QUESTION_PREVIEW_LEN
  if (!isLong) return <p className="whitespace-pre-wrap">{question}</p>
  return (
    <div className="space-y-1">
      <p
        className={
          expanded
            ? "max-h-64 overflow-y-auto whitespace-pre-wrap"
            : "whitespace-pre-wrap"
        }
      >
        {expanded
          ? question
          : `${question.slice(0, QUESTION_PREVIEW_LEN).trimEnd()}…`}
      </p>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="text-primary text-xs hover:underline"
      >
        {expanded ? showLessLabel : showFullLabel}
      </button>
    </div>
  )
}
